import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";

const PastQuestions = ({ items }) => !items.length ? null : (
  <div className="mt-8 border-t border-white/10 pt-6" data-testid="coaching-question-history">
    <p className="text-xs uppercase tracking-widest text-slate-500 mb-3">Your recent questions</p>
    <ul className="space-y-5">
      {items.map((q) => (
        <li key={q.id} className="text-sm" data-testid={`coaching-question-${q.id}`}>
          <span className="text-white">{q.subject.replace(/^Coaching question: /, "")}</span>
          <span className="text-slate-500"> · {fmtDate(q.created_at)}</span>
          {q.reply ? (
            <div className="mt-2 border-l-2 border-[#D4AF37] pl-4" data-testid={`coaching-reply-${q.id}`}>
              <p className="text-xs uppercase tracking-widest text-gold-light">Coach reply · {fmtDate(q.replied_at)}</p>
              <p className="text-slate-300 mt-1 whitespace-pre-line">{q.reply}</p>
            </div>
          ) : <p className="text-xs text-slate-500 mt-1" data-testid={`coaching-awaiting-${q.id}`}>Awaiting reply</p>}
        </li>
      ))}
    </ul>
  </div>
);

export const CoachingInbox = () => {
  const [f, setF] = useState({ subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState([]);
  const load = () => { api.get("/me/coaching-questions").then((r) => setItems(r.data)).catch(() => {}); };
  useEffect(() => { load(); }, []);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/me/coaching-questions", f);
      toast.success("Your question was sent. Todd's team will reply by email.");
      setF({ subject: "", message: "" });
      load();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <section className="card-lux p-6 sm:p-8" data-testid="coaching-inbox">
      <span className="eyebrow">Ask your coach</span>
      <h2 className="font-serif text-2xl font-semibold text-white">Send a coaching question</h2>
      <p className="text-sm text-slate-400 mt-2 mb-6">Your question goes straight to Todd's team. You'll get a reply by email with answers and resources for your situation.</p>
      <form onSubmit={submit} className="space-y-4" data-testid="coaching-question-form">
        <input className="field" placeholder="Topic (e.g. Overcoming fear at work)" value={f.subject} required minLength={2} maxLength={200}
          onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="coaching-question-subject" />
        <textarea className="field min-h-[140px]" placeholder="Share what's going on and what you'd like help with..." value={f.message} required minLength={5} maxLength={5000}
          onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="coaching-question-message" />
        <button disabled={busy} className="btn-gold" data-testid="coaching-question-submit"><Send size={15} /> {busy ? "Sending..." : "Send question"}</button>
      </form>
      <PastQuestions items={items} />
    </section>
  );
};
